// Bilingual (Bahasa Indonesia + English) cue lists for field extraction.
// Used by extract-resume.ts feature-scoring. Lowercased; match case-insensitively.

export const SCHOOL_KEYWORDS = [
  // English
  "university",
  "college",
  "institute",
  "school",
  "polytechnic",
  "academy",
  // Indonesian
  "universitas",
  "institut",
  "sekolah tinggi",
  "politeknik",
  "akademi",
  "stmik",
  "stikes",
  "stie",
]

export const DEGREE_KEYWORDS = [
  // English
  "bachelor",
  "master",
  "doctor",
  "phd",
  "associate",
  "b.s",
  "b.a",
  "m.s",
  "m.a",
  "mba",
  // Indonesian
  "sarjana",
  "magister",
  "doktor",
  "diploma",
  "s1",
  "s2",
  "s3",
  "d3",
  "d4",
  "smk",
  "sma",
  "sederajat",
]

export const GPA_LABELS = ["gpa", "ipk", "cgpa", "grade"]

// Common job-title tokens in both languages (kept compact; partial-match).
export const JOB_TITLE_KEYWORDS = [
  // English
  "intern",
  "manager",
  "engineer",
  "developer",
  "analyst",
  "designer",
  "officer",
  "specialist",
  "coordinator",
  "assistant",
  "lead",
  "head",
  "director",
  "consultant",
  "staff",
  "supervisor",
  "associate",
  "executive",
  "volunteer",
  "freelance",
  "founder",
  "researcher",
  // Indonesian
  "magang",
  "manajer",
  "kepala",
  "staf",
  "asisten",
  "koordinator",
  "direktur",
  "pendiri",
  "relawan",
  "ketua",
  "wakil",
  "anggota",
  "pengurus",
  "peneliti",
]

// Small Indonesian + common city list to help location detection. The "City,
// Region" comma pattern is the primary signal; this list is a fallback.
export const CITY_KEYWORDS = [
  "jakarta",
  "bandung",
  "surabaya",
  "medan",
  "semarang",
  "yogyakarta",
  "jogja",
  "depok",
  "bekasi",
  "tangerang",
  "bogor",
  "malang",
  "makassar",
  "denpasar",
  "palembang",
  "batam",
  "solo",
  "indonesia",
]

export const EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i
export const PHONE_REGEX = /(?:\+?62|0)[\d\s().-]{7,}\d/
export const URL_REGEX =
  /(?:https?:\/\/)?(?:www\.)?(?:linkedin\.com|github\.com|[a-z0-9-]+\.[a-z]{2,})(?:\/[^\s]*)?/i
// "City, Region" or "City, ST" pairs.
export const LOCATION_REGEX = /[A-Z][a-zA-Z.]+(?:\s[A-Z][a-zA-Z.]+)*,\s?[A-Z][a-zA-Z.]+/

export function containsKeyword(text: string, keywords: string[]): boolean {
  const lower = text.toLowerCase()
  return keywords.some((keyword) => lower.includes(keyword))
}
